var _path, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgThreePointRectangle = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 24,
    viewBox: "0 0 24 24",
    width: 24,
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m4.110246 5.110104h15.779792v11.779792h-15.779792z",
    fill: "none",
    stroke: "#8cbe8c",
    strokeWidth: 3.220208
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(33.000142)"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "#c4a000",
    height: 11,
    rx: 2.01149,
    width: 11,
    x: -20,
    y: 13
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#fcffff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m-15 14v2.0625c-.537663.111041-1.024662.383291-1.375.78125l-1.78125-1.03125-.5.875 1.78125 1.03125c-.082063.247432-.125.506395-.125.78125s.04294.533818.125.78125l-1.78125 1.03125.5.875 1.78125-1.03125c.352503.40042.832682.670182 1.375.78125v2.0625h1v-2.0625c.537663-.111041 1.024662-.383291 1.375-.78125l1.78125 1.03125.5-.875-1.78125-1.03125c.082063-.247432.125-.506395.125-.78125s-.04294-.533818-.125-.78125l1.78125-1.03125-.5-.875-1.78125 1.03125c-.352503-.40042-.832682-.670182-1.375-.78125v-2.0625zm.5 3.5c.552 0 1 .448 1 1s-.448 1-1 1-1-.448-1-1 .448-1 1-1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m-19 19 9-.0096s0 0 0-2c0-2.9904-1-2.9904-4.5-2.9904s-4.5 0-4.5 3z",
    fillRule: "evenodd",
    opacity: 0.3
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    fill: "#bebebe",
    stroke: "#8c8c8c"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m18.403627 3.6286861h3v3.0000002h-3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m2.661 15.274799h3v3h-3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m2.661 3.6286862h3v3h-3z"
  }))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgThreePointRectangle, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/three_point_rectangle.f410c62a.svg";
export { ForwardRef as ReactComponent };